import React, { useState, useEffect } from 'react';

function Notifications() {
  const [messages, setMessages] = useState(() => {
    const saved = localStorage.getItem('khepri_notifications');
    return saved ? JSON.parse(saved) : [];
  });
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('khepri_notification_settings');
    return saved ? JSON.parse(saved) : { tax: true, cash: true, recommendations: true };
  });
  const [pushEnabled, setPushEnabled] = useState(false);

  useEffect(() => {
    const es = new EventSource('http://localhost:8000/api/v1/notifications/stream');

    es.addEventListener('tax_reminder', (e) => {
      if (settings.tax) {
        const data = JSON.parse(e.data);
        setMessages(prev => {
          const updated = [{ type: 'tax', data, time: new Date().toLocaleTimeString('ru-RU') }, ...prev].slice(0, 50);
          localStorage.setItem('khepri_notifications', JSON.stringify(updated));
          return updated;
        });
      }
    });

    es.addEventListener('cash_alert', (e) => {
      if (settings.cash) {
        const data = JSON.parse(e.data);
        setMessages(prev => {
          const updated = [{ type: 'cash', data, time: new Date().toLocaleTimeString('ru-RU') }, ...prev].slice(0, 50);
          localStorage.setItem('khepri_notifications', JSON.stringify(updated));
          return updated;
        });
        if (pushEnabled && 'Notification' in window && Notification.permission === 'granted') {
          new Notification(data.title, { body: data.message });
        }
      }
    });

    return () => es.close();
  }, [settings, pushEnabled]);

  const toggleSetting = (key) => {
    setSettings(prev => {
      const updated = { ...prev, [key]: !prev[key] };
      localStorage.setItem('khepri_notification_settings', JSON.stringify(updated));
      return updated;
    });
  };

  const enablePush = async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        setPushEnabled(true);
        new Notification('Khepri', { body: 'Push-уведомления включены!' });
      }
    }
  };

  const clearAll = () => {
    setMessages([]);
    localStorage.removeItem('khepri_notifications');
  };

  return (
    <div>
      <h2>Уведомления</h2>

      {/* Настройки */}
      <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <h3 style={{ marginBottom: 12, color: '#F7DE8A' }}>⚙️ Настройки уведомлений</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={settings.tax} onChange={() => toggleSetting('tax')} style={{ width: 18, height: 18 }} />
            📅 Налоговые напоминания
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={settings.cash} onChange={() => toggleSetting('cash')} style={{ width: 18, height: 18 }} />
            💰 Кассовые уведомления
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={settings.recommendations} onChange={() => toggleSetting('recommendations')} style={{ width: 18, height: 18 }} />
            💡 Рекомендации ИИ
          </label>
        </div>
        {!pushEnabled && (
          <button
            onClick={enablePush}
            style={{
              marginTop: 12,
              padding: '10px 20px',
              background: '#F7DE8A',
              color: '#0F172A',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            🔔 Включить push-уведомления
          </button>
        )}
        {pushEnabled && (
          <p style={{ marginTop: 12, color: '#10B981', fontSize: 13 }}>✅ Push-уведомления включены</p>
        )}
      </div>

      {/* Список уведомлений */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <h3>📬 Лента уведомлений</h3>
        {messages.length > 0 && (
          <button onClick={clearAll} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>
            Очистить все
          </button>
        )}
      </div>

      {messages.length === 0 && <p style={{ color: '#94A3B8' }}>Ожидание уведомлений...</p>}

      {messages.map((m, i) => (
        <div key={i} style={{ padding: 12, marginBottom: 8, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
            <strong style={{ color: m.type === 'tax' ? '#F7DE8A' : '#10B981' }}>{m.data.title}</strong>
            <span style={{ fontSize: 11, color: '#94A3B8' }}>{m.time}</span>
          </div>
          <p style={{ fontSize: 13, color: '#94A3B8' }}>{m.data.message}</p>
        </div>
      ))}
    </div>
  );
}

export default Notifications;